import React, { useState } from 'react';
import Image from 'next/image';
import styled from '@emotion/styled';
import {
  breakpoints,
} from 'src/js/nextgen/plushcare-components';
import closeWindowImg from 'public/img/icon-close.svg';
import infoIcon from 'public/img/chameleon/info_icon_crisis.svg';
import { useUserData } from 'src/js/endpoints/users';

export default function CrisisManagementMessage({ shortVersion }: { shortVersion?: boolean }) {
  const [hideMessage, setHideMessage] = useState(false);
  const { data: user } = useUserData();

  const isEnterprise = user?.is_enterprise_user;
  const additionalEnterpriseStr = 'to speak with an Accolade mental health nurse ';
  const phoneNo = user?.accolade_support_phone_number;

  if (hideMessage) return null;

  return (
    <CrisisContainer>
      <CrisisBanner data-testid="crisis-banner">
        <ImageContainer>
          <Image src={infoIcon} width={16} height={16} alt="Info icon" />
        </ImageContainer>
        {
          shortVersion || isEnterprise ? (
            <p>
              For mental health emergencies, please
              {' '}
              <b>
                call 911
                {phoneNo && ` or ${phoneNo} `}
              </b>
              { phoneNo && additionalEnterpriseStr }
              {' '}
              or visit your nearest
              {' '}
              <b>hospital emergency room</b>
              .
            </p>
          ) : (
            <p>
              If you or someone you know is experiencing a medical or psychiatric emergency
              and needs immediate help,
              {' '}
              <b>call 911</b>
              {' '}
              or go to your nearest
              {' '}
              <b>emergency room</b>
              .
            </p>
          )
        }
        <CloseImageContainer>
          <Image
            aria-hidden="true"
            aria-label="Close"
            onClick={() => setHideMessage(true)}
            alt="Exit"
            src={closeWindowImg}
            width={18}
            height={18}
          />
        </CloseImageContainer>
      </CrisisBanner>
    </CrisisContainer>
  );
}

const CrisisContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  @media (max-width: ${breakpoints.desktop}) {
    position: fixed;
    bottom: 0;
    left: 0;
  }
`;

const CrisisBanner = styled.div`
  background-color: #F4F4F4;
  border: 1px solid #E5E5E5;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 14px;
  padding-right: 10px;
  margin-top: 30px;
  p {
    flex: 1;
    padding-top: 4px;
    margin-bottom: 0px;
    margin-right: 10px;
  }
  @media (max-width: ${breakpoints.desktop}) {
    width: 100%;
  }
`;

const ImageContainer = styled.div`
  min-width: 24px;
  max-width: 24px;
`;

const CloseImageContainer = styled.div`
  @media (min-width: ${breakpoints.desktop}) {
    display: none;
  }
  cursor: pointer;
  min-width: 13px;
  max-width: 13px;
`;
